import { Component, Input, SimpleChanges } from '@angular/core';
import { DetailPrescriptionHospitComponent } from "./detail-prescription-hospit/detail-prescription-hospit.component";
import { DetailPrestationHospitComponent } from "./detail-prestation-hospit/detail-prestation-hospit.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
type ViewMode = 'exec' | 'pres';

@Component({
  selector: 'app-detail-hospit',
  imports: [DetailPrescriptionHospitComponent, DetailPrestationHospitComponent,FormsModule,CommonModule],
  templateUrl: './detail-hospit.component.html',
  styleUrl: './detail-hospit.component.scss'
})
export class DetailHospitComponent {
viewMode: ViewMode = 'pres'; // Default view
  @Input() itemBeneficiare:any


  setView(mode: 'exec' | 'pres'): void {
    this.viewMode = mode;
  }

    ngOnChanges(changes: SimpleChanges) {
      console.log('changes: ',changes)
    if (changes['itemBeneficiare'] && changes['itemBeneficiare'].currentValue) {
      console.log("changes['itemBeneficiare']: ",changes['itemBeneficiare'])
      this.itemBeneficiare = changes['itemBeneficiare'].currentValue
    
    }
  }
}
